import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

export const C1SwitchTheme: Components<Theme>['MuiSwitch'] = {
    styleOverrides: {
        root: ({ theme, ownerState }) => theme.unstable_sx({
            // Dimensions are from "antSwitch" variant: https://v4.mui.com/components/switches/#customized-switches
            // & tweaked to match bounding box of default MUI switch

            '&.MuiSwitch-root': {
                height: 40,
            },

            '& .MuiSwitch-switchBase': {
                padding: '2px',
                margin: '12px',

                '&:hover': {
                    backgroundColor: 'action.hover',
                },

                '&.Mui-focusVisible': {
                    backgroundColor: 'action.focus',
                    '& .MuiSwitch-thumb': {
                        boxShadow: '0 0 0 2px',
                        color: 'primary.main',
                    },
                },

                '&.Mui-checked': {
                    color: '#fff',
                    transform: 'translateX(18px)',

                    '&:hover': {
                        backgroundColor: 'action.hover',
                    },

                    '&.Mui-focusVisible': {
                        backgroundColor: 'action.focus',
                        '& .MuiSwitch-thumb': {
                            boxShadow: '0 0 0 2px',
                            color: 'success.main',
                        },
                    },

                    '& + .MuiSwitch-track': {
                        opacity: 1,
                        backgroundColor: ownerState.color === 'warning' ? 'warning.main' : 'success.light',
                    },
                },
            },

            '& .MuiSwitch-thumb': {
                boxShadow: 'none',
                width: '12px',
                height: '12px',
                borderRadius: '6px',
            },

            '& .MuiSwitch-track': {
                borderRadius: '8px',
                opacity: 1,
                boxSizing: 'border-box',
                backgroundColor: 'grey.300',
            },
        }),
    },
}
